/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Pipe, PipeTransform } from '@angular/core'
import { NameCapableObject } from '@seiri/shared/common'

@Pipe({
  name: 'getInitials',
})
export class GetUserInitialsPipe implements PipeTransform {
  transform(user?: NameCapableObject | null, fallback = 'US'): string {
    if (!user) {
      return fallback
    }
    if (
      user.firstName &&
      typeof user.firstName === 'string' &&
      user.firstName.length > 0 &&
      user.lastName &&
      typeof user.lastName === 'string' &&
      user.lastName.length > 0
    ) {
      return `${user.firstName[0]!.toUpperCase()}${user.lastName[0]!.toUpperCase()}`
    }

    if (user.firstName && typeof user.firstName === 'string' && user.firstName.length > 1) {
      return `${user.firstName[0]!.toUpperCase()}${user.firstName[1]!.toUpperCase()}`
    }

    if (user.lastName && typeof user.lastName === 'string' && user.lastName.length > 1) {
      return `${user.lastName[0]!.toUpperCase()}${user.lastName[1]!.toUpperCase()}`
    }

    if (user.name && typeof user.name === 'string' && user.name.length > 1) {
      return `${user.name[0]!.toUpperCase()}${user.name[1]!.toUpperCase()}`
    }

    if (user.fullName && typeof user.fullName === 'string' && user.fullName.length > 1) {
      const [firstName, lastName] = user.fullName.split(' ')
      if (firstName && lastName) {
        return `${firstName[0]!.toUpperCase()}${lastName[0]!.toUpperCase()}`
      }
      if (firstName && firstName.length > 1) {
        return `${firstName[0]!.toUpperCase()}${firstName[1]!.toUpperCase()}`
      }
    }

    if (user.email?.length && user.email.includes('@')) {
      const [address, domain] = user.email.split('@')
      if (typeof address === 'string' && address.length > 2) {
        return address.substring(0, 2).toUpperCase()
      }
      if (typeof address === 'string' && address.length === 1 && typeof domain === 'string' && domain.length > 0) {
        return `${address.toUpperCase()}${domain[0]!.toUpperCase()}`
      }
    }

    return fallback.toUpperCase()
  }
}
